import { Component, inject, OnInit } from '@angular/core';
import { Activities } from '../../components/activities/activities';
import { NavCampaigns } from '../../components/campaign/nav-campaigns/nav-campaigns';
import { Api } from '../../services/api';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { PermissionService } from '../../services/permission.service';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';

@Component({
  selector: 'app-campaign-detail',
  imports: [NavCampaigns, CommonModule, FormsModule, DatePipe],
  templateUrl: './campaign-detail.html',
  styleUrl: './campaign-detail.css'
})
export class CampaignDetail implements OnInit{
  public api = inject(Api);

  public campana_id: string = '';
  public campana: any = [];

  readonly dialog = inject(MatDialog);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public permissionService: PermissionService,
    
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.campana_id = params['id'];
      this.getCampaignDetails();
    });
  }

  getCampaignDetails(){
    this.api.getCampaignById({campana_id: this.campana_id}).subscribe({
      next: (data:any)=>{
        console.log('Campaign data received:', data);
        this.campana = data.campana;
      },
      error: (err:any)=>{
        console.error('Error fetching campaign details:', err);
        Swal.fire({
          icon: 'error',
          title: 'Atención',
          text: ' La campana no existe o ha sido eliminada.',
          denyButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#d33',
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(() => {
          this.router.navigate(['/campaigns']);
        });
      }
    });
  }

  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.campana,
        mode: 'call',
        tipo: 'PRO',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewTask(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.campana,
        mode: 'task',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.campana,
        mode: 'event',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }
}
